import { Icon as e } from "../icon/index.js";
import { cn as t } from "../cn.js";
import { getStyles as n } from "./style.js";
import * as r from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
// src/design/alert/index.tsx
var o = ({ title: o, description: s, icon: c, closable: l = !1, onClose: u, config: d, colorScheme: f, variant: p, children: m, className: h, ...g }) => {
	let _ = n({
		colorScheme: f,
		variant: p,
		...d
	}), [v, y] = r.useState(!0), b = () => {
		y(!1), u?.();
	};
	if (!v) return null;
	let x = () => c ? typeof c == "string" ? /* @__PURE__ */ i(e, {
		name: c,
		className: _.icon()
	}) : /* @__PURE__ */ i("div", {
		className: _.icon(),
		children: c
	}) : null;
	return /* @__PURE__ */ a("div", {
		className: t(_.root(), h),
		role: "alert",
		...g,
		children: [
			x(),
			/* @__PURE__ */ a("div", {
				className: _.content(),
				children: [
					o && /* @__PURE__ */ i("div", {
						className: _.title(),
						children: o
					}),
					s && /* @__PURE__ */ i("div", {
						className: _.description(),
						children: s
					}),
					m
				]
			}),
			l && /* @__PURE__ */ i("button", {
				type: "button",
				onClick: b,
				className: _.closeButton(),
				"aria-label": "Close alert",
				children: /* @__PURE__ */ i(e, {
					name: "X",
					className: "w-4 h-4"
				})
			})
		]
	});
}, s = r.createContext(void 0), c = (e) => n(e ?? r.useContext(s)), l = r.forwardRef(({ children: e, className: r, config: a, ...o }, c) => {
	let l = n(a);
	return /* @__PURE__ */ i(s.Provider, {
		value: a,
		children: /* @__PURE__ */ i("div", {
			ref: c,
			role: "alert",
			className: t(l.root(), r),
			...o,
			children: e
		})
	});
});
l.displayName = "Alert.Root";
var u = r.forwardRef(({ name: n, children: r, className: a, config: o, ...s }, l) => {
	let u = c();
	return n ? /* @__PURE__ */ i("div", {
		ref: l,
		className: t(u.icon(), a),
		...s,
		children: /* @__PURE__ */ i(e, { name: n })
	}) : /* @__PURE__ */ i("div", {
		ref: l,
		className: t(u.icon(), a),
		...s,
		children: r
	});
});
u.displayName = "Alert.Icon";
var d = r.forwardRef(({ children: e, className: n, ...r }, a) => {
	let o = c();
	return /* @__PURE__ */ i("div", {
		ref: a,
		className: t(o.content(), n),
		...r,
		children: e
	});
});
d.displayName = "Alert.Content";
var f = r.forwardRef(({ children: e, className: n, config: r, ...a }, o) => {
	let s = c(r);
	return /* @__PURE__ */ i("div", {
		ref: o,
		className: t(s.title(), n),
		...a,
		children: e
	});
});
f.displayName = "Alert.Title";
var p = r.forwardRef(({ children: e, className: n, config: r, ...a }, o) => {
	let s = c(r);
	return /* @__PURE__ */ i("div", {
		ref: o,
		className: t(s.description(), n),
		...a,
		children: e
	});
});
p.displayName = "Alert.Description";
var m = r.forwardRef(({ children: e, className: n, config: r, ...a }, o) => {
	let s = c(r);
	return /* @__PURE__ */ i("div", {
		ref: o,
		className: t(s.actions(), n),
		...a,
		children: e
	});
});
m.displayName = "Alert.Actions";
var h = r.forwardRef(({ className: n, config: r, ...a }, o) => {
	let s = c(r);
	return /* @__PURE__ */ i("button", {
		ref: o,
		type: "button",
		className: t(s.closeButton(), n),
		"aria-label": "Close alert",
		...a,
		children: /* @__PURE__ */ i(e, {
			name: "X",
			className: "w-4 h-4"
		})
	});
});
h.displayName = "Alert.CloseButton";
var g = Object.assign(o, {
	Root: l,
	Icon: u,
	Content: d,
	Title: f,
	Description: p,
	Actions: m,
	CloseButton: h,
	getStyles: n
});
export { g as Alert };

//# sourceMappingURL=index.js.map